// extracted by mini-css-extract-plugin
export var blue = "_4c-h";
export var brand = "_4c-d";
export var darkGrey = "_4c-g";
export var disabled = "_4c-6";
export var disabledSubtle = "_4c-7";
export var error = "_4c-8";
export var green = "_4c-i";
export var grey = "_4c-f";
export var icon = "_4c-0";
export var inherit = "_4c-c";
export var lightGrey = "_4c-e";
export var orange = "_4c-k";
export var pink = "_4c-m";
export var primary = "_4c-1";
export var purple = "_4c-n";
export var quaternary = "_4c-4";
export var quinary = "_4c-5";
export var red = "_4c-l";
export var secondary = "_4c-2";
export var success = "_4c-b";
export var tertiary = "_4c-3";
export var warning = "_4c-9";
export var warningSecondary = "_4c-a";
export var white = "_4c-o";
export var yellow = "_4c-j";